import { getAuthAxiosBackend } from "../../helpers/axios"

class InjuryServices{

    get(id){
        return getAuthAxiosBackend().get('housing-units/woundeds/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('housing-units/woundeds', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('housing-units/woundeds/' + id)
    }
}

export default new InjuryServices()